import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbsoluteValue, Picker, TimePicker} from '../../interface/TimePicker';

@Component({
  selector: 'c-absolute',
  templateUrl: './absolute.component.html',
  styleUrls: ['./absolute.component.css']
})
export class AbsoluteComponent implements OnInit {

  @Output() cChangeTime: EventEmitter<Picker> = new EventEmitter<Picker>();

  @Input() set cTime(value: AbsoluteValue) {
    if (!value) {
      return;
    }
    this.time = value;
    console.log(this.time);
    this.range = [new Date(value.startTime), new Date(value.endTime)];
  }

  public range: Array<Date>;

  private time: AbsoluteValue;

  constructor() {
    this.range = [new Date(), new Date()];
  }

  ngOnInit() {
  }

  public selectChange() {
    this.time.startTime = this.range[0].getTime();
    this.time.endTime = this.range[1].getTime();
    console.log(this.time);
    this.cChangeTime.emit({
      title: '',
      value: {...this.time}
    });
  }

}
